import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import AnnuityRorReport from "src/components/Report/AnnuityRorReport";
import { getPrintClient } from "src/services/client";
import { PrintClient } from "src/types";
import PrintReady from "src/components/PrintReady";

const AnnuityRorPrintPage = () => {
  const [client, setClient] = useState<PrintClient>({} as any);
  const { id, scenarioId } = useParams();
  useEffect(() => {
    if (id)
      getPrintClient(id).then((data) => {
        setClient(data);
      });
  }, [id, scenarioId]);
  const scenario = parseInt(scenarioId || "");
  if (!client) return <div>Loading client...</div>;

  const settings = client.annuityRoRCalculators?.find((s) => s.id == scenario);

  if (!settings) return <div>Loading calculator... </div>;
  return (
    <>
      <AnnuityRorReport settings={settings as any} client={client} />
      <PrintReady />
    </>
  );
};

export default AnnuityRorPrintPage;
